import { useQuery, useMutation } from 'react-query'
import useCacheKeys from '../use-cache-keys'
import useCache from '../use-cache'
import { apiRequester, apiEndpoints } from '../../utilities/api'
import { useCallback, useEffect, useState } from 'react'
import { get } from 'lodash'
import useApi from '../use-api'

const useUserGoalMutations = ({
    userId,
    goalId,
    onSuccess = () => {},
    onError = () => {},
}) => {

    const cacheKeys = useCacheKeys()
    const [ userGoal, setUserGoal ] = useState({})
    const { clearCache } = useCache({ key: cacheKeys.USER_GOALS, onReload: onSuccess })
    const { api, endpoints, url } = useApi()

    const {
        data,
        isLoading
    } = useQuery(
        [cacheKeys.USER_GOALS, goalId],
        () => api.get(url(endpoints.userGoal, { goalId })),
        {
            enabled: Boolean(goalId),
            onSuccess: userGoal => setUserGoal(userGoal)
        }
    )

    useEffect(() => {
        const content = get(userGoal, 'content', '') || ''
        if (content.length > 255) {
            setUserGoal({ ...userGoal, content: content.substring(0, 254 )})
        }
    }, [userGoal])

    useEffect(() => {
        const title = get(userGoal, 'title', '') || ''
        if (title.length > 255) {
            setUserGoal({ ...userGoal, title: title.substring(0, 254 )})
        }
    }, [userGoal])

    const {
        title,
        content,
        dimensions
    } = userGoal

    const [createGoal, { isLoading: isCreating }] = useMutation(
        () => api.post(url(endpoints.userGoals, { userId }), { title, content, dimensions }),
        {
            onSuccess: clearCache,
            onError,
        }
    )

    const [updateGoal, { isLoading: isUpdating }] = useMutation(
        () => api.patch(url(endpoints.userGoal, { goalId }), { title, content, dimensions }),
        {
            onSuccess: clearCache,
            onError,
        }
    )

    const [deleteGoal, { isLoading: isDeleting }] = useMutation(
        (overrideId) => api.get(url(endpoints.userGoal, { goalId: overrideId || goalId })),
        {
            onSuccess: clearCache,
            onError,
        }
    )

    const saveUserGoal = useCallback(() => {
        if(userGoal.id) {
            updateGoal()
        } else {
            createGoal()
        }
    }, [userGoal])

    return {
        isSaving: isCreating || isUpdating,
        isLoading,
        userGoal,
        setUserGoal,
        saveUserGoal,
        deleteGoal,
        isDeleting,
    }
}

export default useUserGoalMutations